
export const errorTitles = Object.freeze({
  THROTTLE_LIMIT_REACHED: 'couponScan.rksvLimitReachedDialogTitle',
  RKSV_REQUIRE_IMAGE_VALIDATION: 'couponScan.noteTitle',
  ALREADY_REDEEMED: 'couponScan.noteTitle',
  RKSV_EXPIRED: 'couponScan.rksvExpiredTitle',
  RKSV_ADDED_TO_QUEUE: 'couponScan.receiptUploadSuccessDialogTitle',
  RKSV_ALREADY_IN_QUEUE: 'couponScan.noteTitle'
});

export const errorCodes = Object.freeze({
  BOUNTY_NOT_PARTICIPATED: 'errorMessages.bountyNotParticipated',
  COUPON_NOT_VALID: 'couponScan.couponNotValid',
  COUPON_ALREADY_REDEEMED: 'couponScan.couponAlreadyRedeemed',
  COUPON_DOES_NOT_EXIST: 'couponScan.couponDoesNotExist',
  COUPON_NOT_ACTIVE: 'couponScan.couponNotActive',

  THROTTLE_LIMIT_REACHED: 'couponScan.rksvLimitReachedDialogText',
  RKSV_REQUIRE_IMAGE_VALIDATION: 'couponScan.rksvRequireImageValidationText',
  ALREADY_REDEEMED: 'couponScan.alreadyRedeemedText',
  NOT_VALID: 'couponScan.notValid',
  INVALID_SIGNATURE: 'couponScan.invalidSignature',
  RKSV_EXPIRED: 'couponScan.rksvExpiredText',
  RKSV_VERIFY_EXCEPTION: 'couponScan.rksvVerifyException',
  RKSV_ADDED_TO_QUEUE: 'couponScan.receiptUploadSuccessDialogText',
  RKSV_ALREADY_IN_QUEUE: 'couponScan.receiptAlreadyInQueue'
});
